export const COORDINATES_REGEX = /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/;

export const formatCoordinates = (lat?: number, lng?: number): string => {
  if (lat !== undefined && lng !== undefined) {
    return `${lat}, ${lng}`;
  }
  return '';
};

export const parseCoordinates = (input: string): { lat?: number; lng?: number } => {
  const trimmed = input.trim();
  if (!trimmed || !COORDINATES_REGEX.test(trimmed)) {
    return { lat: undefined, lng: undefined };
  }

  const parts = trimmed.split(',').map((part) => part.trim());
  const lat = parseFloat(parts[0]);
  const lng = parseFloat(parts[1]);

  return {
    lat: !isNaN(lat) ? lat : undefined,
    lng: !isNaN(lng) ? lng : undefined,
  };
};
